import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import DashBoardLayerOne from "../../components/DashBoardLayerOne";
import CategoriesTable from "../../components/CategoryManagement/CategoriesTable";
import SubCategoriesTable from "../../components/CategoryManagement/SubCategoriesTable";
import AddNewCategory from "../../components/CategoryManagement/AddNewCategory";


const AddNewCategoryPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title="Add Category " subtitle={"Categories"} subUrl={"/categories"} />

                <AddNewCategory />
                {/* DashBoardLayerOne */}
                {/* <DashBoardLayerOne /> */}

            </MasterLayout>
        </>
    );
};

export default AddNewCategoryPage;
